import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

// Simple Bar Chart Component
interface BarChartProps {
    data: Array<{
        label: string;
        value: number;
        displayValue: string;
        color: string;
        hasData: boolean;
        periodDescription?: string | undefined;
    }>;
    maxValue: number;
    height?: number;
    showDifference?: boolean;
}

const BarChart: React.FC<BarChartProps> = ({ data, maxValue, showDifference = false }) => {
    // Calculate difference if we have exactly 2 data points with data
    const validData = data.filter(item => item.hasData);
    const difference = showDifference && validData.length === 2
        ? Math.abs((validData[0]?.value || 0) - (validData[1]?.value || 0))
        : null;

    return (
        <div className="bar-chart">
            <div className="bar-chart-container">
                {data.map((item) => (
                    <div key={`bar-${item.label}`} className="bar-item">
                        <div className="bar-label">
                            <Text strong>{item.label}</Text>
                        </div>
                        <div className="bar-wrapper">
                            {item.hasData ? (
                                <>
                                    <div
                                        className="bar"
                                        style={{
                                            width: `${(item.value / maxValue) * 100}%`,
                                            backgroundColor: item.color,
                                            height: '30px',
                                            position: 'relative',
                                        }}>
                                        {item.periodDescription && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                color: 'white',
                                                fontSize: '10px',
                                                fontWeight: 'bold',
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '90%',
                                            }}>
                                                {item.periodDescription}
                                            </div>
                                        )}
                                    </div>
                                    <div className="bar-value">
                                        <Text>{item.displayValue}</Text>
                                    </div>
                                </>
                            ) : (
                                <div className="no-data">
                                    <Text type="secondary">Nėra duomenų</Text>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <div className="bar-chart-footer">
                <Text type="secondary">Maks.: {maxValue}</Text>
                {difference !== null && !Number.isNaN(difference) && (
                    <Text type="secondary" style={{ marginLeft: 16 }}>
                        Skirtumas: {difference.toFixed(3).replace(/\.?0+$/, '')}
                    </Text>
                )}
            </div>
        </div>
    );
};

BarChart.defaultProps = {
    height: 120,
    showDifference: false,
};

export default BarChart;
